import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import ModalComponent from '../../../../../../layout/Modals/ModalComponent/ModalComponent';
import {
  createSavedSearch,
} from '../../../../../../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import { connectModalContainerContextToComponent } from '../../../../../../../contexts/ModalContext/ModalContext';
import savedSearchPropType from '../../../../../../../utility/PropTypes/savedSearchPropType';

// TODO: feedback for success/fail request res (maybe toast messages?)
function SaveNewSavedSearchModal({
  setModalJSX,
  newSavedSearch,
  entityTypeId,
  setActiveSavedSearchToEdit,
}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(true);
  const [name, setName] = useState(newSavedSearch.name);
  const [description, setDescription] = useState(newSavedSearch.description);
  const [error, setError] = useState(false);

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  const handleSubmitSavedSearch = async () => {
    newSavedSearch.name = name;
    newSavedSearch.description = description;
    newSavedSearch.type = entityTypeId;
    try {
      const response = await dispatch(createSavedSearch(newSavedSearch)).unwrap();
      setActiveSavedSearchToEdit(response);
      closeModalHandler();
    } catch (e) {
      setError(true);
    }
  };

  /* istanbul ignore next */
  return (
    <ModalComponent
      show={show}
      close={closeModalHandler}
      showConfirmCallToAction
      confirmButtonText="Save"
      confirmButtonAction={handleSubmitSavedSearch}
      isBtnDisabled={!name}
    >
      <Modal.Header closeButton>
        <Modal.Title>Save This Search</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={(e) => {
          e.preventDefault();
          if (name) {
            handleSubmitSavedSearch().then(() => {});
          }
        }}
        >
          <div className="container">
            {error && (
            <div className="row">
              <div className="col">
                <ErrorBanner onCloseError={() => setError(false)}>
                  Unexpected error saving search.
                </ErrorBanner>
              </div>
            </div>
            )}
            <div className="form-group">
              <label htmlFor="saved-search-name" style={{ width: '100%' }}>
                Name
                <input
                  type="text"
                  name="saved-search-name"
                  id="saved-search-name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control"
                  placeholder=""
                />
              </label>
            </div>
            <div className="form-group">
              <label htmlFor="saved-search-description" style={{ width: '100%' }}>
                Description ( Optional)
                <textarea
                  className="form-control"
                  rows="3"
                  name="saved-search-description"
                  id="saved-search-description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder=""
                />
              </label>
            </div>
          </div>
        </form>
      </Modal.Body>
    </ModalComponent>
  );
}

SaveNewSavedSearchModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  newSavedSearch: PropTypes.shape(savedSearchPropType).isRequired,
  entityTypeId: PropTypes.number.isRequired,
  setActiveSavedSearchToEdit: PropTypes.func.isRequired,
};
export { SaveNewSavedSearchModal };
export default connectModalContainerContextToComponent(SaveNewSavedSearchModal);
